import {
    eventTypes,
    createProfileRequested,
    createProfileReceived,
    createProfileFetchFailed,
    userIdOf,
    apiTokenOf
  } from './model';

const makeTransduce = ({oauth, redirect, profile}) => getState => event => {

    if (!event || !event.type)  {
        return Promise.resolve([]);
    }

    if (event.type === eventTypes.LOGIN_REQUESTED) {

        const dest = oauth.token.getUri();
        redirect(dest);

        return Promise.resolve([]);

    }

    if (event.type === eventTypes.TOKEN_RECEIVED_FROM_URL) {
        return Promise.resolve([
            createProfileRequested()
        ]);
    }

    if (event.type === eventTypes.PROFILE_REQUESTED) {
        const userId = userIdOf(getState());
        const apiToken = apiTokenOf(getState());
        return profile(apiToken, userId)
            .then(createProfileReceived)
            .catch(() => createProfileFetchFailed())
            .then(evt => [evt]);
    }

    return Promise.resolve([]);

};

export {makeTransduce};



// WEBPACK FOOTER //
// ./src/user/transducer.js